import React from 'react';
import { Card } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Separator } from '../components/ui/separator';

const HeroMockLanes = () => {
  const mockDecisions = [
    {
      lane: 'build',
      title: 'Mobile App',
      segment: 'Enterprise',
      signal: 'Would pay 5x for iOS + Android apps. 200 users waiting.',
      reasoning: 'High revenue opportunity',
      channel: 'LinkedIn'
    },
    {
      lane: 'fix',
      title: 'Pricing Confusion',
      segment: 'Paid',
      signal: 'Your pricing page is super confusing. About to cancel.',
      reasoning: 'High churn risk',
      channel: 'X'
    },
    {
      lane: 'ignore',
      title: 'Dark Mode',
      segment: 'Trial',
      signal: 'Please add dark mode! Would be nice.',
      reasoning: 'Low impact',
      channel: 'Reddit'
    }
  ];

  const getLaneColor = (lane) => {
    switch (lane) {
      case 'build':
        return 'lane-build';
      case 'fix':
        return 'lane-fix';
      default:
        return 'lane-ignore';
    }
  };

  const getLaneTitle = (lane) => {
    switch (lane) {
      case 'build':
        return '🚀 Build Next';
      case 'fix':
        return '⚠️ Fix Now';
      default:
        return '❌ Ignore';
    }
  };

  return (
    <div 
      className="rounded-2xl border bg-card shadow-lg overflow-hidden max-w-5xl mx-auto"
      data-testid="hero-mock-visual"
    >
      <div className="grid md:grid-cols-3 divide-x divide-border">
        {mockDecisions.map((decision, index) => (
          <div key={index} className={`p-4 ${getLaneColor(decision.lane)}`}>
            <div className="mb-3">
              <h3 className="text-xs font-semibold text-muted-foreground mb-2">
                {getLaneTitle(decision.lane)}
              </h3>
            </div>
            
            <Card className="p-3 space-y-2">
              <div className="flex items-center justify-between">
                <p className="text-sm font-semibold">{decision.title}</p>
                <Badge variant="secondary" className="text-xs">
                  {decision.segment}
                </Badge>
              </div>
              
              <Separator />
              
              <p className="text-xs text-muted-foreground line-clamp-2">
                {decision.signal}
              </p>
              
              <div className="flex items-center justify-between pt-1">
                <span className="text-xs text-muted-foreground">{decision.channel}</span>
                <span className="text-xs font-medium">{decision.reasoning}</span>
              </div>
            </Card>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HeroMockLanes;
